$(document).ready(() => {
    const PAGE_LENGTH = 10;

    $('.playerVersusStatsBlock').each(setupTable);

    function setupTable() {
        const $playerStatsBlock = $(this);

        let gamesTypeFilter = 'all';
        let tournamentFilter = 'all';
        let tournamentTierFilter = 'all';
        let displayStart = 0;
        let order = [[4, 'desc']];

        const currentUrl = TRNMNT_helpers.parseUrl();
        const $gameTypeFilter = $playerStatsBlock.find('.gameTypeFilter');
        const $tournamentFilter = $playerStatsBlock.find('.tournamentFilter');
        const $tournamentTierFilter = $playerStatsBlock.find('.tournamentTierFilter');

        const preserveFiltering = currentUrl.segments.indexOf('player') !== -1;

        if (preserveFiltering && currentUrl.params) {
            if (currentUrl.params.pvgtf) {
                $gameTypeFilter.val(currentUrl.params.pvgtf);
                gamesTypeFilter = currentUrl.params.pvgtf;
            }
            if (currentUrl.params.pvtf) {
                $tournamentFilter.val(currentUrl.params.pvtf);
                tournamentFilter = currentUrl.params.pvtf;
            }
            if (currentUrl.params.pvttrf) {
                $tournamentTierFilter.val(currentUrl.params.pvttrf);
                tournamentTierFilter = currentUrl.params.pvttrf;
            }
            if (currentUrl.params.pvds) {
                displayStart = currentUrl.params.pvds;
            }
            if (currentUrl.params.pvoc && currentUrl.params.pvod) {
                order = [[currentUrl.params.pvoc, currentUrl.params.pvod]];
            }
        }

        const columns = TRNMNT_helpers.playerVersusTableColumns();

        const $table = $playerStatsBlock.find('.playersVersusStatsTable')
            // .on('processing.dt', function (e, settings, processing) {
            //     $('#players_processing')
            //         .addClass('bg-dark')
            //         .css('display', processing ? 'block' : 'none')
            //         .html('Загружаются данные...');
            // })
            .DataTable({
                language: {
                    url: '/dataTables.ru.json'
                },
                scrollX: true,
                displayStart: displayStart,
                pageLength: PAGE_LENGTH,
                lengthChange: false,
                info: false,
                // processing: true,
                serverSide: true,
                ajax: {
                    url: PLAYERS_VERSUS_URL,
                    data: function (d) {
                        if (gamesTypeFilter !== 'all') {
                            d.games_type = gamesTypeFilter;
                        }
                        if (tournamentFilter !== 'all') {
                            d.tournament_id = tournamentFilter;
                        }
                        if (tournamentTierFilter !== 'all') {
                            d.tier = tournamentTierFilter;
                        }
                    },
                },
                order: order,
                search: {
                    return: true,
                },
                paging: !MAIN,
                searching: false,
                dataSrc: 'data',
                columns: [
                    columns.index, //Порядковый 0
                    columns.avatar, //Аватар 1
                    columns.platform, //Платформа 2
                    columns.name, //Имя 3

                    columns.cups,//GP 4
                    columns.games,//GP 5
                    columns.wins,//P 6
                    columns.loses,//P 7
                    columns.lose_overtime,//P 8
                    columns.wins_percent,//P 9
                    columns.goals_for,//P 9
                    columns.goal_diff,//P 9
                    columns.shots,//P 9
                    columns.hits,//P 9
                    columns.pass_percent,//P 9
                    columns.faceoff,//P 9
                    columns.powerplay,//P 9
                    columns.shorthanded_goals,//P 9
                ],
                createdRow(row) {
                    // $(row).addClass(tournamentTypeFilter === '3' ? 'bg-3x3' : 'bg-dark');
                    $(row).addClass('bg-dark');
                },
                initComplete: (settings, json) => {
                    $('div.dataTables_filter input').addClass('form-control-dark');
                }
            });

        if (preserveFiltering) {
            $table.on('page.dt', function () {
                const info = $table.page.info();
                const displayStart = info.page * PAGE_LENGTH;
                TRNMNT_helpers.insertURLQueryParam('pds', displayStart);

                $([document.documentElement, document.body]).animate({
                    scrollTop: $playerStatsBlock.find('.playersVersusStatsTable').offset().top - 160
                }, 0);
            });

            $table.on('order.dt', function () {
                // This will show: "Ordering on column 1 (asc)", for example
                const order = $table.order();
                TRNMNT_helpers.insertURLQueryParam('poc', order[0][0]);
                TRNMNT_helpers.insertURLQueryParam('pod', order[0][1]);
                TRNMNT_helpers.insertURLQueryParam('pds', 0);
            });
        }

        $gameTypeFilter.on('change', event => {
            event.preventDefault();
            gamesTypeFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvgtf', gamesTypeFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvoc', 4);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvod', 'desc');

            $table.draw();
        });

        $tournamentFilter.on('change', event => {
            event.preventDefault();
            tournamentFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvtf', tournamentFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvoc', 4);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pvod', 'desc');

            $table.draw();
        });

        $tournamentTierFilter.on('change', event => {
            event.preventDefault();
            tournamentTierFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pttrf', tournamentTierFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('poc', 4);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pod', 'desc');

            $table.draw();
        });
    }
});
